import { render, staticRenderFns } from "./ButtonLink.vue?vue&type=template&id=9d40e4fc"
import script from "./ButtonLink.vue?vue&type=script&lang=js"
export * from "./ButtonLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports